import type { PosTypeDto } from "../../types/PosTypeDto";
import type { PosTypeEntity } from "../../types/PosTypeEntity";

export const PosTypeDtoToEntity = ({ ...rest }: Readonly<PosTypeDto>): PosTypeEntity => {
    return { ...rest };
};
